import { isEmpty } from 'lodash/fp';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { useGetTradeInQuery } from '../../../api/queries/getTradeIn';
import { ApplicationDetailsExtraContext } from '../../../components/contexts/ApplicationDetailsExtraContext';
import LoadingElement from '../../../components/LoadingElement';
import { useThemeComponents } from '../../../themes';
import NotFoundPage from '../../portal/NotFoundPage';
import TradeInForm from './TradeInForm';

export enum TradeInTabKey {
    TradeIn = 'tradeIn',
    ActivityLog = 'activityLog',
}

const TradeInDetailsPage = () => {
    const { t } = useTranslation('tradeInDetails');
    const { id } = useParams();
    const { PageWithHeader } = useThemeComponents();
    const navigate = useNavigate();

    const { data, loading } = useGetTradeInQuery({
        variables: {
            id,
        },
    });
    const tradeIn = data?.tradeIn;

    const extra = useMemo(() => ({ forCI: false }), []);

    if (loading) {
        return <LoadingElement />;
    }

    if (isEmpty(tradeIn)) {
        return <NotFoundPage />;
    }

    return (
        <ApplicationDetailsExtraContext.Provider value={extra}>
            <PageWithHeader
                onBack={() => navigate(-1)}
                title={t('tradeInDetails:title', { id: tradeIn?.identifier ?? '' })}
            >
                <TradeInForm tradeIn={tradeIn} />
            </PageWithHeader>
        </ApplicationDetailsExtraContext.Provider>
    );
};

export default TradeInDetailsPage;
